import { Button, useTailwindBreakpoint } from '@eye-able/ui';
import LanguageSelect from '@components/LanguageSelect';
import NotificationSection from '@layout/Header/NotificationSection';
import { IconAccessible, IconLogout } from '@tabler/icons-react';
import ProfileSection from './ProfileSection';
import { useTranslation } from 'react-i18next';
import { demoModeAtom } from '@/global-store';
import useLogoutFn from '@/hooks/useLogoutFn';
import { useAtom } from 'jotai';
import { cn } from '@helpers/cn';

const ICON_SIZE = '1.38rem';

function HeaderActions() {
  const { t } = useTranslation();
  const [demoMode] = useAtom(demoModeAtom);
  const logoutFn = useLogoutFn();
  const isDesktop = useTailwindBreakpoint('xl');

  return (
    <nav
      id='header-right-section'
      aria-label={t('topNavAria')}
      className={cn(!isDesktop && 'eye:w-full')}
    >
      <ul
        className={cn(
          'eye:flex eye:gap-4xs eye:items-center eye:justify-between',
          !isDesktop && 'eye:py-2xs eye:px-s',
        )}
      >
        <li>
          <Button
            type='button'
            size={isDesktop ? 'default' : 'icon'}
            variant='ghost'
            id='eyeAble_customToolOpenerID'
            onClick={openAssistDefault}
          >
            <IconAccessible size={ICON_SIZE} />
            <span className='eye:max-xl:sr-only'>{t('accessibility')}</span>
          </Button>
        </li>
        <li>
          <LanguageSelect />
        </li>
        <li>
          <NotificationSection />
        </li>
        <li>
          {demoMode ? (
            <Button
              type='button'
              size={isDesktop ? 'default' : 'icon'}
              variant='ghost'
              onClick={() => {
                void logoutFn();
              }}
            >
              <IconLogout size={ICON_SIZE} />
              <span className='eye:max-xl:sr-only'>{t('exit')}</span>
            </Button>
          ) : (
            <ProfileSection />
          )}
        </li>
      </ul>
    </nav>
  );
}

function openAssistDefault() {
  try {
    window.EyeAbleAPI?.toggleToolbar();
  } catch (e) {
    console.log(e);
  }
}

export default HeaderActions;
